export const MEDIA_QUERIES = {
  MOBILE_SMALL: 480,
  MOBILE_LARGE: 732,
  TABLET_SMALL: 868,
  TABLET_LARGE: 1144,
  DESKTOP: 1145,
}
